export enum ValueTypeEnum {
  PERCENTAGE = 'PERCENTAGE',
  VALUE = 'VALUE'
}
